import React from 'react';
import TextField from '@material-ui/core/TextField';
import {FormControl, Button, Typography} from "@material-ui/core";
import { Visibility, VisibilityOff } from '@material-ui/icons';
import logo from '../../icons/img/CropSensePartners.png'
import Carrusel from "./Carrusel";
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {connect} from "react-redux";
import EsIcon from "../../icons/PNGs/es.png";
import EnIcon from "../../icons/PNGs/en.png";

const texts = require('../../texts/login.json');


interface IProps {
    user: string
    password: string
    error: null | string
    view: boolean
    hover: string
    idioma: string
    setContacta(contacta: boolean): void
    setForgetPass(forget_pass: boolean): void
    setUser(user: string): void
    setPassword(password: string): void
    setError(error: null | string): void
    setView(view: boolean): void
    setHover(hover: string): void
    setSubmit(submit: boolean): void
    changeLanguage(idioma: string): void
}

interface IState {
    text: Record<string, string>
}

class LoginMain extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma]
    };

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: '100vh',
                    width: '100vw',
                    overflow: 'hidden'
                }}
            >

                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        width: '50%',
                        height: '100%',
                        verticalAlign: 'center'
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            width: '100%',
                            height: 100
                        }}
                    >

                        <img
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                marginRight: 10,
                                cursor: "pointer",
                                opacity: this.props.idioma === "es"? 1 : 0.3
                            }}
                            onClick={() => {
                                if (this.props.idioma !== "es") this.props.changeLanguage("es")
                            }}
                            src={EsIcon}
                            alt={'es'}
                        />



                        <img
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                marginRight: 10,
                                cursor: "pointer",
                                opacity: this.props.idioma === "en"? 1 : 0.3
                            }}
                            onClick={() => {
                                if (this.props.idioma !== "en") this.props.changeLanguage("en")
                            }}
                            src={EnIcon}
                            alt={'en'}
                        />

                    </div>

                    <div
                        style= {{
                            width: 371,
                            height: 100,
                            // marginTop: 100,
                            marginBottom: 15
                        }}
                    >
                        <img width= '360'
                             src= {logo}
                             alt=''
                        />
                    </div>

                    <TextField
                        style={{
                            margin: 8,
                            width: 360,
                            fontSize: 30
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        value={this.props.user}
                        error={this.props.error != null}
                        label={this.props.error != null ? this.props.error : this.state.text["0"]}
                        placeholder={this.state.text["0"]}
                        onChange={(e) => this.props.setUser(e.target.value)}

                    />
                    <FormControl
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 372
                        }}
                    >
                        <TextField
                            style={{
                                width: 360,
                                fontSize: 30,
                                margin: 8,
                                marginBottom: 35,
                                marginRight: 0
                            }}
                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            value={this.props.password}
                            type={this.props.view? 'text' : 'password'}
                            error={this.props.error != null}
                            label={this.props.error != null ? this.props.error : this.state.text["1"]}
                            placeholder={this.state.text["1"]}
                            onChange={(e) => this.props.setPassword(e.target.value)}
                            onKeyPress={(e) => (e.key === 'Enter') && this.props.setSubmit(true)}
                        />
                        {this.props.view?
                            <Visibility
                                style={{
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    color: this.props.hover === 'vis'? "black" : '#4C494B',
                                    marginTop: -10,
                                    marginLeft: -30,
                                    zIndex: 10
                                }}
                                onMouseEnter={() => this.props.setHover('vis')}
                                onMouseLeave={() => this.props.setHover('')}
                                onClick={() => this.props.setView(false)}
                            />
                            :
                            <VisibilityOff
                                style={{
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    color: this.props.hover === 'vis'? "black" : '#4C494B',
                                    marginTop: -10,
                                    marginLeft: -30,
                                    zIndex: 10
                                }}
                                onMouseEnter={() => this.props.setHover('vis')}
                                onMouseLeave={() => this.props.setHover('')}
                                onClick={() => this.props.setView(true)}
                            />
                        }
                    </FormControl>

                    <Button
                        style= {{
                            width: 360,
                            height: 51,
                            backgroundColor: '#fd8379',
                            borderRadius: 10,
                            fontSize: 20,
                            marginBottom: 25,
                        }}
                        variant={'contained'}
                        onClick={() => this.props.setSubmit(true)}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 20,
                                fontWeight: "bold",
                                textTransform: "none"
                            }}
                        >
                            {this.state.text["2"]}
                        </Typography>
                    </Button>

                    <div
                        style= {{
                            width: 366,
                            height: 90,
                            marginTop: 9,
                        }}
                    >
                        <a
                            href="#"
                            style= {{
                                fontSize: 20,
                                textDecoration: 0,
                                color: 'black',
                                fontWeight: 'bold',
                                fontFamily: "Poppins"
                            }}
                            onClick={() => this.props.setForgetPass(true)}
                        >
                            {this.state.text["5"]}
                        </a>
                    </div>
                </div>

                <div
                    style={{
                        width: '50%',
                        height: '100%',
                        backgroundSize: 'contain'
                    }}
                >
                    <Carrusel />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    user: state.login.user,
    password: state.login.password,
    error: state.login.error,
    view: state.login.view,
    hover: state.login.hover,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setContacta: (contacta: boolean) => dispatch({type: "set-login-contacta", contacta}),
    setForgetPass: (forget_pass: boolean) => dispatch({type: "set-login-forget-pass", forget_pass}),
    setUser: (user: string) => dispatch({type: "set-login-user", user}),
    setPassword: (password: string) => dispatch({type: "set-login-password", password}),
    setError: (error: null | string) => dispatch({type: "set-login-error", error}),
    setView: (view: boolean) => dispatch({type: "set-login-view", view}),
    setHover: (hover: string) => dispatch({type: "set-login-hover", hover}),
    setSubmit: (submit: boolean) => dispatch({type: "set-login-submit", submit}),
    changeLanguage: (idioma: string) => dispatch({type: 'choose-config-idioma', idioma})
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginMain);
